var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCard',[_c('h2',[_vm._v(_vm._s(_vm.dataToDisplay))]),_c('p',[_vm._v(_vm._s(_vm.captionToDisplay))])])}
var staticRenderFns = []

export { render, staticRenderFns }